<template>
  <div id="app" class="h-100">
    <nav-bar v-model="filters" />
    <div class="container-fluid content">
      <div class="row h-100">
        <main class="col-lg-7 p-0 green">
          <keep-alive>
            <router-view :ufos="ufosFiltered" v-model="filters" />
          </keep-alive>
        </main>
        <div class="col sidebar">
          <div class="row h-50">
            <div class="col chart-top">
              <ufo-chart-top :ufos="ufos" v-model="filters" @update="loadGeojson" />
            </div>
          </div>
          <div class="row h-50">
            <div class="col chart-bottom">
              <ufo-chart-bottom :ufos="ufos" v-model="filters" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import UfoChartTop from '@/components/UfoChartTop.vue';
import UfoChartBottom from '@/components/UfoChartBottom.vue';

import ufoService from '@/services/ufo-service';

import defaultFilters from '@/assets/misc/default-filters';

const API_URL = 'data/ufos_3000_geo.json';
// const API_URL = 'data/ufo_1997_geo.json';

export default {
  data() {
    return {
      ufoService,
      ufos: [],
      url: '',
      filters: { ...defaultFilters },
    };
  },
  created() {
    this.ufoService.getUfos(API_URL).then((data) => {
      this.ufos = data;
    });
  },
  computed: {
    ufosFiltered() {
      return this.ufos.filter((feature) => {
        let result = true;
        Object.keys(this.filters).forEach((filterParam) => {
          result = result && (this.filters[filterParam].length === 0
          || this.filters[filterParam].includes(feature.properties[filterParam]));
        });
        return result;
      });
    },
  },
  methods: {
    loadGeojson(geoJsonURL) {
      this.ufoService.getUfos(geoJsonURL).then((data) => {
        this.ufos = data;
      });
    },
  },
  components: {
    NavBar,
    UfoChartTop,
    UfoChartBottom,
  },
};
</script>


<style>
.content {
  height: calc(100% - 56px);
  line-height: 1;
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  main {
    min-width: calc(100% - 413px);
    max-width: calc(100% - 413px);
  }
  .sidebar {
    min-width: 413px;
    max-width: 413px;
  }
}

.chart-top {
  color: white;
  background-color: #1E1E1E;
}
.chart-bottom {
  color: white;
  background-color: #252526;
}
.green {
  background-color: lightgreen;
}
#nav {
  padding: 30px;
}
.ufo-green {
  background-color: rgb(36, 226, 36);
}
</style>
